var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document"},[_c('main-menu'),_c('v-app',{attrs:{"id":"inspire"}},[_c('h1',{staticClass:"notice"},[_vm._v("There are no B/L Instructions yet")]),_c('h2',{staticClass:"notice"},[_vm._v("Once a booking is confirmed, a B/L Instruction record will be created here.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }